
<template>
  <CustomPage :title="$route.query.cateName">
    <div slot="content" style="height: 100%">
      <div class="h-2"></div>
      <GoodsList />
    </div>
  </CustomPage>
</template>

<script>
import GoodsList from "./components/GoodsList";
import CustomPage from "@/components/custom-page.vue";
export default {
  components: {
    CustomPage,
    GoodsList,
  },
};
</script>

<style>
</style>